// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"91":"475c655a","129":"4da7ff29","145":"85b1df46","146":"cb48874c","263":"cb48874c","418":"85b1df46","479":"85b1df46","625":"231d97de","643":"85b1df46"}[chunkId] + ".chunk.css";
};